import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { mkNavigateRelative } from '@suvo/frontend-framework/standalone/router/navigate';
import { take } from 'rxjs/operators';

/** @todo This could probably be a guard */
@Component({
  standalone: false,
  template: '',
})
export class VerifyComponent implements OnInit {
  private readonly activatedRoute = inject(ActivatedRoute);

  private readonly navRel = mkNavigateRelative();

  ngOnInit() {
    this.activatedRoute.queryParams.pipe(take(1)).subscribe((params) => {
      if (params.mode === 'verifyEmail') {
        this.navRel(['../../verify-email/confirmation'], { queryParamsHandling: 'preserve' });
      } else if (params.mode === 'resetPassword') {
        this.navRel(['../../reset-passwor/confirmation'], { queryParamsHandling: 'preserve' });
      } else if (params.mode === 'revertSecondFactorAddition') {
        this.navRel(['../verify/emergency-removal-mfa'], { queryParamsHandling: 'preserve' });
      } else {
        this.navRel(['..']);
      }
    });
  }
}
